import { useState, useEffect } from 'react';
import { Alert, Box } from '@mui/material';
import { setUnprovisionedCallback } from '../providers/cognito';

export const ProvisioningBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setUnprovisionedCallback(setShow);
    return () => { setUnprovisionedCallback(() => {}); };
  }, []);

  if (!show) return null;

  return (
    <Box sx={{ px: 2, pt: 1 }}>
      <Alert severity="warning">
        Your account isn't provisioned in this tenant yet — data will not load. Contact your
        administrator.
      </Alert>
    </Box>
  );
};
